import React from "react";
import { Oval } from 'react-loader-spinner';

const Loader = () => {

    return(
        <div className="mitch-kitch-loader">
            <Oval
                height={44}
                width={44}
                color="#FFFFFF"
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="#9BCFFF"
                strokeWidth={10}
                strokeWidthSecondary={8}
                wrapperClass="mobile-spinner"
            /> 
        </div>
    )
}

const ButtonLoader = () => {
    return(
        <div className="mitch-kitch-button-loader">
            <Oval
                height={25}
                width={25}
                color="#4DA9FF"
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="#FFFFFF"
                strokeWidth={10}
                strokeWidthSecondary={8}
                wrapperClass="mobile-spinner"
            /> 
        </div>
    )
}

const StyledInputLoader = () => {
    return(
        <div className="mitch-kitch-button-loader">
            <Oval
                height={44}
                width={44}
                color="#FFFFFF"
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="#4DA9FF"
                strokeWidth={10}
                strokeWidthSecondary={8}
                wrapperClass="mobile-spinner"
            /> 
        </div>
    )
}

export { Loader, ButtonLoader, StyledInputLoader };